export const RECORDS = 'Records';
export const PHOTOS = 'Photos';
export const FAMILY = 'Family';
export const MAXPHOTOS = 10;
export const NPH_CONFIRM_SAVE = 'nphConfirmSave';
export const NPH_CONFIRM_IGNORE = 'nphConfirmIgnore';
export const NPH_CONFIRM_PERSON_HINTS_CTA = 'nphConfirmPersonHintsCta';

export const NphIconMapper = {
	[RECORDS]: 'iconDocument',
	[PHOTOS]: 'iconCamera',
	[FAMILY]: 'iconFamily'
};

export const NphGenderMapper = {
	m: 'Male',
	f: 'Female',
	u: 'Unknown'
};
